<template>
    
    <!--Main Slider Start-->
    <section class="main-slider clearfix">
        <div class="swiper-container thm-swiper__slider" id="hola" data-swiper-options='{"slidesPerView": 1, "loop": true,
            "effect": "fade",
            "pagination": {
            "el": "#main-slider-pagination",
            "type": "bullets",
            "clickable": true
            },
            "navigation": {
            "nextEl": "#main-slider__swiper-button-next",
            "prevEl": "#main-slider__swiper-button-prev"
            },
            "autoplay": {
            "delay": 5000
            }}'
        >

            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="image-layer"
                        style="background-image: url(assets/images/homeSlider/main-slider1-1.jpg); mix-blend-mode: normal;"></div>
                    <!-- /.image-layer -->

                    <div class="main-slider-shape-1"
                        style="background-image: url(assets/images/shapes/main-slider-shape-1.jpg);"></div>
                        <!-- Img en el slider, debajo del texto lend a helping -->
                    <!-- <div class="main-slider-shape-2 float-bob-x">
                        <img src="assets/images/shapes/main-slider-shape-2.png" alt="">
                    </div> -->

                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-8">
                                <div class="main-slider__content">
                                    <!-- <p class="main-slider__sub-title">Always donate for childrens</p> -->
                                    <h2 class="main-slider__title">Soluciones energéticas e hídricas responsables con el medio ambiente.</h2>
                                    <div class="main-slider__btn-box">
                                        <router-link to="/contact"><a href="#" class="thm-btn main-slider__btn">Contáctanos</a></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="image-layer"
                        style="background-image: url(assets/images/homeSlider/main-slider2.jpeg);  mix-blend-mode: normal;"></div>
                    <!-- /.image-layer -->

                    <div class="main-slider-shape-1"
                        style="background-image: url(assets/images/shapes/main-slider-shape-1.jpg);"></div>
                    <!-- <div class="main-slider-shape-2 float-bob-x">
                        <img src="assets/images/shapes/main-slider-shape-2.png" alt="">
                    </div> -->

                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-8">
                                <div class="main-slider__content">
                                    <!-- <p class="main-slider__sub-title">Always donate for childrens</p> -->
                                    <h2 class="main-slider__title">Soluciones energéticas e hídricas responsables con el medio ambiente.</h2>
                                    <div class="main-slider__btn-box">
                                        <router-link to="/contact"><a href="#" class="thm-btn main-slider__btn">Contáctanos</a></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="image-layer"
                        style="background-image: url(assets/images/homeSlider/main-slider3-1.jpg);  mix-blend-mode: normal;"></div>
                    <!-- /.image-layer -->

                    <div class="main-slider-shape-1"
                        style="background-image: url(assets/images/shapes/main-slider-shape-1.jpg);"></div>
                    <!-- <div class="main-slider-shape-2 float-bob-x">
                        <img src="assets/images/shapes/main-slider-shape-2.png" alt="">
                    </div> -->

                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-8">
                                <div class="main-slider__content">
                                    <!-- <p class="main-slider__sub-title">Always donate for childrens</p> -->
                                    <h2 class="main-slider__title">Soluciones energéticas e hídricas responsables con el medio ambiente.</h2>
                                    <div class="main-slider__btn-box">
                                        <router-link to="/contact"><a href="#" class="thm-btn main-slider__btn">Contáctanos</a></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- If we need navigation buttons -->
            <div class="main-slider__nav">
                <div class="swiper-button-prev" id="main-slider__swiper-button-next" data-bs-target="#hola" data-bs-slide="next" >
                    <i class="icon-left-arrow"  style="color:#FAFADE;"></i>
                </div>
                <div class="swiper-button-next" id="main-slider__swiper-button-prev" data-bs-target="#hola" data-bs-slide="prev">
                    <i class="icon-right-arrow"  style="color:#F7F7E3;"></i>
                </div>
            </div>

        </div>
    </section>
    <!--Main Slider End-->
</template>
    <style>
         @media only screen and (max-width: 768px){
            .main-slider__title{
                font-size: 49px;
                line-height: 72px;
                display: flex;
            }
        }
    </style>

<script>

    export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                // swiper slider
                if ($(".thm-swiper__slider").length) {
                $(".thm-swiper__slider").each(function () {
                    let elm = $(this);
                    let options = elm.data("swiper-options");
                    let thmSwiperSlider = new Swiper(elm, options);
                });
                }
            }
        }
    }
</script>